import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { Fetching } from '../lazy';
import useDevice, { devices } from '../../hooks/useDevice';
import dataAids from '../../../constants/dataAids';

function ProductListWrapper({
  searchResults,
  sortDropdown,
  categories,
  categorySelected,
  children,
  fetching,
  viewDevice
}) {
  const { Block } = UX2.Element;
  const {
    Grid,
    Grid: { Cell }
  } = UX2.Component;
  const [device] = useDevice();
  const isMobile = device === devices.MOBILE || viewDevice === 'MOBILE_RENDER_DEVICE';

  const styles = {
    container: {
      position: 'relative'
    },
    rowContainer: isMobile
      ? {
        position: 'relative',
        marginBottom: 'small'
      }
      : {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 'small'
      },
    selectedCategory: isMobile
      ? {
        position: 'relative',
        marginBottom: 'small'
      }
      : {
        display: 'flex',
        flex: 1,
        marginRight: 'medium',
        justifyContent: 'flex-start'
      }
  };

  const dropdown = sortDropdown && sortDropdown({ withBorder: !!categories && isMobile });

  return (
    <Block style={ styles.wrapper } data-route=''>
      <Block style={ styles.container }>
        { isMobile ? (
          <>
            <Block style={ styles.selectedCategory }>{ categorySelected }</Block>
            <Grid
              spacingXs='xsmall'
              xs={ dropdown && categories ? 2 : 1 }
              style={ styles.rowContainer }
              data-aid={ dataAids.PRODUCT_LIST_MOBILE_RENDERED }
            >
              { categories }
              { dropdown }
            </Grid>
            { searchResults }
            { children }
          </>
        ) : (
          <Grid sm={ categories ? 4 : 3 } data-aid={ dataAids.PRODUCT_LIST_DESKTOP_RENDERED }>
            { categories && <Cell size={ 1 } children={ categories } /> }
            <Cell sm={ 3 }>
              <Block style={ styles.rowContainer }>
                { dropdown }
                <Block style={ styles.selectedCategory }>{ categorySelected }</Block>
                { searchResults }
              </Block>
              { children }
            </Cell>
          </Grid>
        ) }
      </Block>
      <Fetching fetching={ fetching } pageTransition={ true } />
    </Block>
  );
}

ProductListWrapper.propTypes = {
  searchResults: PropTypes.node,
  sortDropdown: PropTypes.func,
  categories: PropTypes.node,
  categorySelected: PropTypes.node,
  children: PropTypes.node,
  fetching: PropTypes.bool,
  viewDevice: PropTypes.string
};

export default ProductListWrapper;
